const AccordionContextKey = Symbol("fh-accordion-context");
export {
  AccordionContextKey
};
//# sourceMappingURL=Symbols.mjs.map
